import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useQuery, UseQueryResult } from 'react-query'
import { DocumentType } from '@dc-shared-web/hooks/api/office/types'
import { fetchDocumentTypesByOffice } from '@dc-shared-web/hooks/api/office/fetchDocumentTypesByOffice'

type UseGetDocumentTypesByOfficeProps = (params: {
  officeUUID?: string
}) => UseQueryResult<DocumentType[], Error>

export const useGetDocumentTypesByOffice: UseGetDocumentTypesByOfficeProps = ({
  officeUUID,
}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<DocumentType[], Error>(
    ['office', officeUUID, 'document-types'],
    async () => {
      if (!officeUUID) {
        throw new Error('Office UUID is required')
      }

      const data = await fetchDocumentTypesByOffice(apiClient, {
        officeUUID,
      })

      return data
    },
    {
      enabled: !!officeUUID,
    }
  )
}
